import IncomeAccountRouting from '../../../../banking/components/paycheck-routing/income-account-routing/IncomeAccountRouting';

export default function IncomeRouting() {
    return <IncomeAccountRouting />;
}
